"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const feeTypes = [
    {
        id: 'RECEIVE_ON_LONG_NUMBER_MONTHLY',
        name: 'Monthly fee · Receive on Long Number',
        feeCategory: 'MONTHLY_FEE',
        description: 'Monthly fee for receive on long number feature',
        overridable: true,
    },
    {
        id: 'RECEIVE_ON_LONG_NUMBER_ESTABLISHMENT',
        name: 'Establishment fee · Receive on Long Number',
        feeCategory: 'ESTABLISHMENT_FEE',
        description: 'Establishment fee for receive on long number feature',
        overridable: true,
    },
    {
        id: 'RBM_BASIC_MESSAGE',
        name: 'RBM basic message',
        feeCategory: 'TRAFFIC_FEE',
        description: 'RBM basic message traffic fee',
        overridable: false,
    },
    {
        id: 'ESTABLISHMENT',
        name: 'Establishment fee',
        feeCategory: 'ESTABLISHMENT_FEE',
        description: 'Product establishment fee',
        overridable: true,
    },
    {
        id: 'MONTHLY',
        name: 'Monthly fee',
        feeCategory: 'MONTHLY_FEE',
        description: 'Product monthly fee',
        overridable: true,
    },
    {
        id: 'RBM_A2P_CONVERSATION',
        name: 'RBM A2P conversation',
        feeCategory: 'TRAFFIC_FEE',
        description: 'RBM conversation traffic fee',
        overridable: false,
    },
    {
        id: 'DOMESTIC',
        name: 'Off net domestic',
        feeCategory: 'TRAFFIC_FEE',
        description: 'SMS domestic net traffic fee',
        overridable: false,
    },
    {
        id: 'FOREIGN',
        name: 'Off net foreign',
        feeCategory: 'TRAFFIC_FEE',
        description: 'SMS foreign net traffic fee',
        overridable: false,
    },
    {
        id: 'HOME',
        name: 'On net',
        feeCategory: 'TRAFFIC_FEE',
        description: 'SMS home net traffic fee',
        overridable: false,
    },
    {
        id: 'BLOCKED',
        name: 'Blocked',
        feeCategory: 'TRAFFIC_FEE',
        description: 'SMS fee for blocked traffic',
        overridable: false,
    },
    {
        id: 'RECEIVE_ON_SHORT_NUMBER_MONTHLY',
        name: 'Monthly fee · Receive on Short Number',
        feeCategory: 'MONTHLY_FEE',
        description: 'Monthly fee for receive on short number feature',
        overridable: true,
    },
    {
        id: 'RBM_SINGLE_MESSAGE',
        name: 'RBM single message',
        feeCategory: 'TRAFFIC_FEE',
        description: 'RBM single message traffic fee',
        overridable: false,
    },
    {
        id: 'RBM_AGENT',
        name: 'RBM agent',
        feeCategory: 'MONTHLY_FEE',
        description: 'RBM active agent monthly fee',
        overridable: false,
    },
    {
        id: 'RECEIVE_ON_SHORT_NUMBER_ESTABLISHMENT',
        name: 'Establishment fee · Receive on Short Number',
        feeCategory: 'ESTABLISHMENT_FEE',
        description: 'Establishment fee for receive on short number feature',
        overridable: true,
    },
];
exports.default = feeTypes;
